import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getPersonsAction } from '../redux/actions/personActions'
import { getPersonsRequest } from '../api/personApi'

export const usePersonApi = () => {
  const dispatch = useDispatch()

  const getPersons = useCallback(async () => {
    await getPersonsRequest()
      .then(response => {
        dispatch(getPersonsAction(response.data))
      })
      .catch(error => {
        console.error(error)
      })
  }, [])


  return {
    getPersons
  }
}
